<template>
  <div class="blik-waiting-screen">
    <h1 class="blik-page__title">{{ $t('blik__waiting_title') }}</h1>
    <p class="blik-page__intro">{{ $t('blik__waiting_subtitle') }}</p>

    <div class="blik-page__note">
      {{ $t('blik__waiting_note') }}
    </div>

    <button
      v-if="hasReturnUrl"
      type="button"
      class="blik-page__btn blik-page__btn--primary"
      @click="$emit('return')">
      {{ $t('blik__waiting_btn_return') }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    hasReturnUrl: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
